type Guard = {
  enabled: () => boolean;
  message: () => string;
  confirmAsync?: () => Promise<boolean>;
};

let guard: Guard | null = null;

let swallow = 0;
let allowNext = false;

let handling = false;

const stop = (e: PopStateEvent) => {
  try {
    (e as any).stopImmediatePropagation?.();
    e.stopPropagation?.();
  } catch {}
};

export const initPopupPopstateGuard = () => {
  window.addEventListener(
    'popstate',
    (e) => {
      if (swallow > 0) {
        swallow -= 1;
        stop(e);
        return;
      }

      if (allowNext) {
        allowNext = false;
        return;
      }

      if (!guard) return;

      let shouldBlock = false;
      try {
        shouldBlock = Boolean(guard.enabled());
      } catch {
        shouldBlock = false;
      }

      if (!shouldBlock) return;

      stop(e);

      if (handling) return;
      handling = true;

      const finish = (ok: boolean) => {
        if (ok) {
          allowNext = true;
          window.history.back();
          handling = false;
          return;
        }

        swallow += 1;
        window.history.forward();
        handling = false;
      };

      const confirm = guard.confirmAsync
        ? guard.confirmAsync()
        : Promise.resolve(window.confirm(guard.message()));

      confirm.then(finish).catch(() => finish(false));
    },
    { capture: true },
  );
};

export const setPopupPopstateGuard = (next: Guard | null) => {
  guard = next;
};

export const silentGo = (delta: number) => {
  if (delta === 0) return;
  swallow += 1;
  window.history.go(delta);
};
